<textarea name="tinymce" ngDefaultControl id="{{ elementId }}">{{ initialContent || '' }}</textarea>
